import type { VariantCatalog } from "../types";

export function findCombinationByPartNo(
  catalog: VariantCatalog,
  partNo: string,
) {
  return catalog.combinations.find(
    (combination) => combination.partNo === partNo,
  );
}
